import type { ReactNode } from 'react';
import { formatPercent } from '../lib/format';

interface ProgressCardProps {
  title: string;
  eyebrow: string;
  actual: string;
  target: string;
  progress: number;
  icon: ReactNode;
  color: string;
  hint?: string;
}

export default function ProgressCard({ title, eyebrow, actual, target, progress, icon, color, hint }: ProgressCardProps) {
  const safe = Number.isFinite(progress) ? Math.max(0, progress) : 0;
  const ringValue = Math.min(safe, 100);
  return (
    <article className="progress-card">
      <div className="progress-card-copy">
        <span className="eyebrow">{eyebrow}</span>
        <h3>{title}</h3>
        <div className="progress-actual">{actual}</div>
        <div className="progress-target">目标 {target}</div>
        {hint && <div className="progress-hint">{hint}</div>}
      </div>
      <div
        className="progress-ring"
        style={{ '--progress': `${ringValue * 3.6}deg`, '--ring-color': color } as React.CSSProperties}
        aria-label={`达成率 ${formatPercent(safe)}`}
      >
        <span className="progress-ring-icon">{icon}</span>
        <strong>{formatPercent(safe, 0)}</strong>
      </div>
    </article>
  );
}
